import { gql, TypedDocumentNode } from '@common/hooks';
import {
  DeleteWorkerProfileChangeMutationCgResponse,
  DeleteWorkerProfileChangeMutationVariables,
} from '@common/graphql';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

export const DELETE_WORKER_PROFILE_CHANGE_MUTATION: TypedDocumentNode<
  DeleteWorkerProfileChangeMutationCgResponse,
  DeleteWorkerProfileChangeMutationVariables
> = gql`
  mutation DeleteWorkerProfileChange(
    $workerId: ID!
    $scheduleGroupId: ID!
    $termId: ID!
    $schedulingPeriodId: ID
  ) {
    deleteWorkerProfileChange(
      workerId: $workerId
      serviceLineId: $scheduleGroupId
      termId: $termId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      worker {
        id
        name
        terms {
          id
          active
          effectiveStartDate
          effectiveEndDate
          employmentType
          role
          homeUnit
          ftePercentage
          preferredTime
          chargeEligible
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
